import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import React from 'react';

import { SelectSearchFormField } from '@/components/form/SelectSearchFormField.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { CustomerStatusFieldProps } from '@/views/customers/status/useCustomerStatusField.util.ts';

type Props = {
  disabled: boolean;
  field: CustomerStatusFieldProps;
  label: string;
};

/** The `status` field of a customer form; hidden from creators without CUSTOMER_APPROVE. */
export const CustomerStatusFormField: React.FC<Props> = ({ disabled, field, label }) => {
  const { t } = useTranslationWithPrefix('views.customers.status.formField');

  if (!field.isVisible) {
    return null;
  }

  return (
    <Grid size={4}>
      <SelectSearchFormField
        disabled={disabled || field.isLocked}
        isNotClearable
        label={label}
        name="status"
        options={field.options}
      />
      {field.isLocked && <FormHelperText>{t('lockedHint')}</FormHelperText>}
    </Grid>
  );
};
